import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import GamePage from "@/pages/GamePage";
import StatsPage from "@/pages/StatsPage";

function App() {
  return (
    <AppProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/play" element={<GamePage />} />
            <Route path="/stats" element={<StatsPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              border: "2px solid #111111",
              borderRadius: "10px",
              background: "#ffffff",
              color: "#111111",
              fontFamily: "Work Sans, sans-serif",
              fontWeight: 600,
              boxShadow: "4px 4px 0px #111111",
            },
          }}
        />
      </div>
    </AppProvider>
  );
}

export default App;
